/**
 * User model
 * 
 * @class User
 */
export default class User {
    constructor({
        password = "",
        email = "",
        firstName = "",
        lastName = "",
        phone = null,
        birthdate = null,
        locale = null,
        gender = null,
        title = null,
    } = {}) {
        this.Password = password;
        this.Email = email;
        this.FirstName = firstName;
        this.LastName = lastName;
        this.Phone = phone;
        this.Birthdate = birthdate;
        this.Locale = locale;
        this.Gender = gender;
        this.Title = title;
    }
}
